module.exports = __webpack_public_path__ + "static/media/bitmovin_8pp_encoding_graphic.d6e0d98d.svg";